import toast from "react-hot-toast";
import * as api from "../Api";

// create a  new asset
export const getCategory = () => async (dispatch) => {
  try {
    const { data } = await api.fetchCategory();
    dispatch({ type: "FETCH_ALL", payload: data });
  } catch (error) {}
};

export const createCompanyCategory = (postData) => async (dispatch) => {
  let creatingIdCatId;
  try {
    creatingIdCatId = toast.loading("Creating Category...");
    const { data } = await api.CompanyCategory(postData);
    dispatch({ type: "CREATE_CATEGORY", payload: data });
    toast.remove(creatingIdCatId);
    toast.success("Category created successfully");
  } catch (error) {
    toast.remove(creatingIdCatId);
    toast.error(error.message);
  }
};
